import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONSTANTS } from 'src/app/constants/users.constants';
import { GENERAL_CONSTANTS, TRANSFIYA_ATTEMPT_TIME_LIMIT, TRANSFIYA_ORDER_STATUS, TRANSFIYA_TIME_TO_REQUEST_AGAIN, TRANSFIYA_TRANSFER_PARAMS } from 'src/app/core/constants/General-constants';
import { Transaction } from 'src/app/models/transaction';
import { PrintServicesService } from 'src/app/services/print-services.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import moment from 'moment';
import { AlertService } from 'src/app/services/alert.service';
import { TransfiyaService } from 'src/app/services/transfiya.service';
import { finalize } from 'rxjs/operators';
import { TransfiyaResponse } from 'src/app/models/transfiya-response.model';

@Component({
  selector: 'app-transfiya-voucher',
  templateUrl: './transfiya-voucher.component.html',
  styleUrls: ['./transfiya-voucher.component.scss']
})

export class TransfiyaVoucherComponent implements OnInit {

  transaction: Transaction;
  transferId = '';
  checkoutToken = '';
  currentDate = moment().format('DD/MM/YYYY');

  timeIntervalToRequestAgain = TRANSFIYA_TIME_TO_REQUEST_AGAIN;
  tryLeftConsult = TRANSFIYA_ATTEMPT_TIME_LIMIT / TRANSFIYA_TIME_TO_REQUEST_AGAIN;

  isPending = true;
  isRejected = false;
  loading = false;

  responseOrderStatus = { title: 'pending-transfer-Title', message: 'accept-transfer-by-phone' };
  pendingStatuses = [
    TRANSFIYA_ORDER_STATUS.PENDING,
    TRANSFIYA_ORDER_STATUS.CREATED,
    TRANSFIYA_ORDER_STATUS.ACCEPTED
  ];

  static loadStyle() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `./assets/css/root/default.css`;
    document.getElementsByTagName('HEAD')[0].appendChild(link);
  }

  constructor(
    private readonly printServicesService: PrintServicesService,
    private readonly tokenService: TokenServiceService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly router: Router,
    private readonly transfiyaService: TransfiyaService
  ) { }

  ngOnInit() {
    this.transaction = this.tokenService.getAndDecodeToken();

    this.activatedRoute.queryParams.subscribe(params => {
      this.transferId = params[TRANSFIYA_TRANSFER_PARAMS.TRANSFER_ID] ?? '';
      this.checkoutToken = params[TRANSFIYA_TRANSFER_PARAMS.TOKEN] ?? '';
    });

    TransfiyaVoucherComponent.loadStyle();

    this.consultOrderState();
  }

  /**
   * @description Function to query the transfiya order status
  */
  async consultOrderState() {
    this.loading = true;

    try {
      if (this.tryLeftConsult > 0) {

        this.transfiyaService
          .transfiyaConsult(this.checkoutToken, this.transferId)
          .pipe(finalize(() => (this.loading = false)))
          .subscribe({
            next: (response: TransfiyaResponse) => {

              if(response.CODE !== GENERAL_CONSTANTS.OK_RESPONSE_CODE) return this.pending();
            
              if (response.DATA && response.DATA.status != '' && this.pendingStatuses.includes(response.DATA.status)) {
                this.isPending = true,
                this.intervalLogic();
                
                return;
              }

              this.processResponseOrder(response.DATA ? response.DATA.status : '');
            },
            error: (_) => {
              this.rejected();
              this.alertService.showAlertProblem();
            } 
          });
      } else {
        this.loading = false;
      }
    } catch (_) {
      this.rejected();

      this.alertService.showAlertProblem();
      this.loading = false;
    }
  }

  /**
   * @description processResponseOrder Process the response of the order
   */
  processResponseOrder(status: string) {
    this.loading = false;

    switch (status) {
      case TRANSFIYA_ORDER_STATUS.PENDING:
      case TRANSFIYA_ORDER_STATUS.CREATED:
      case TRANSFIYA_ORDER_STATUS.ACCEPTED:
      case TRANSFIYA_ORDER_STATUS.INITIATED:
        this.pending();
        break;
      case TRANSFIYA_ORDER_STATUS.COMPLETED:
        this.completed();
        break;
      case TRANSFIYA_ORDER_STATUS.REJECTED:
      case TRANSFIYA_ORDER_STATUS.ERROR:
        this.rejected();
        break;
      default:
        this.pending();
        break;
    }
  }

  /**
   * @description intervalLogic logic to add waiting times for payment order
   */
  intervalLogic() {
    const retryRequestInterval = setInterval(async () => {
      if (this.timeIntervalToRequestAgain <= 0) {
        this.timeIntervalToRequestAgain = TRANSFIYA_TIME_TO_REQUEST_AGAIN;

        clearInterval(retryRequestInterval);
        this.tryLeftConsult--;

        this.consultOrderState();
      } else {
        this.timeIntervalToRequestAgain = this.timeIntervalToRequestAgain - 1;
      }
    }, 1000);
  }

  /**
   * @description Function to set the status of the transaction as pending
   */
  pending() {
    this.responseOrderStatus.title = 'pending-transfer-Title';
    this.responseOrderStatus.message = 'accept-transfer-by-phone';
    this.isPending = true;
    this.intervalLogic();
  }

  /**
   * @description Function to set the status of the transaction as rejected
   */
  rejected() {
    this.isPending = false;
    this.isRejected = true;
    this.responseOrderStatus.title = 'failed-pay-title';
  }

  /**
   * @description Function to set the status of the transaction as completed
   */
  completed() {
    this.responseOrderStatus.title = 'success-Pay-Title';
    this.isPending = false;
    this.isRejected = false;
  }

  /**
   * @description Function to print the payment receipt
  */
  printPaymentReceipt = () => { this.printServicesService.downloadImage(document.getElementById('ticketDiv'), CONSTANTS.PAYMENT_RECEIPT_TITLE) }

  /**
   * @description Function to retry the payment
  */
  retryPayment = () => { this.router.navigate(['/'], { queryParams: { token: this.checkoutToken } }) }

  /**
   * @description Function to consult the status of the transaction and restart the attempts
  */
  consultTransfiyaStatus = () => { 
    this.tryLeftConsult = TRANSFIYA_ATTEMPT_TIME_LIMIT / TRANSFIYA_TIME_TO_REQUEST_AGAIN;

    this.consultOrderState();
  }
}
